/**
 * Centralized Storage Key Constants
 * Use these instead of string literals to prevent typos and ensure consistency
 * 
 * Note: Some keys use snake_case for backward compatibility with existing data
 */
export const STORAGE_KEYS = {
  // Cart
  CART: 'rainbowSails_cart',
  
  // User/Auth
  USER: 'rainbowSails_user',
  USERS: 'rainbowSails_users',
  
  // Currency
  CURRENCY: 'rainbowSails_currency',
  
  // Reviews (snake_case for backward compatibility)
  REVIEWS: 'rainbow_sails_reviews',
  
  // Orders (snake_case for backward compatibility)
  ORDERS: 'rainbow_sails_orders',
  
  // Products (snake_case for backward compatibility)
  PRODUCTS: 'rainbow_sails_products',
  GALLERY_PRODUCTS: 'gallery_products',
  PRODUCTS_CACHE: 'products_cache',
  
  // Events (snake_case for backward compatibility)
  EVENTS: 'rainbow_sails_events',
  
  // Analytics
  ANALYTICS: 'rainbowSails_analytics',
  
  // Logs
  LOGS: 'rainbowSails_logs',
  
  // Settings
  DEBUG_MODE: 'debugMode',
  VISITED: 'rainbow_sails_visited',
  PLAYLIST: 'rainbow_sails_playlist',
  
  // Admin
  AUTO_APPROVAL: 'rainbow_sails_auto_approval',
  EDIT_PRODUCT_DATA: 'edit_product_data',
  
  // Product Builder
  SAVED_PRODUCTS: 'savedProducts'
};

